/**
 * @file 模型选型banner
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */

import { banner } from './../../constants';

const ModelBanner: React.FC = () => (
    <div className="paddle-model-banner">
        <div className="paddle-model-banner-title">{banner.title}</div>
        <div className="paddle-model-banner-desc">{banner.desc}</div>
    </div>
);

export default ModelBanner;
